import CancelWorkFlowDialog from '@ovComponents/3-pattern/cancelWorkFlowDialog/cancelWorkFlowDialog';
import { Button } from 'hephaestus/web';
import { useState } from 'react';

export type ReviewAccountAllocationsCancelProp = {
  label: string;
  workflowCompletionId: string;
  onWorkflowCancelled?: () => void;
};

// Cancels and closes the whole workflow, the same way the edit step does.
export const ReviewAccountAllocationsCancel = ({
  label,
  workflowCompletionId,
  onWorkflowCancelled,
}: ReviewAccountAllocationsCancelProp) => {
  const [confirming, setConfirming] = useState(false);

  return (
    <>
      <Button
        type='button'
        variant='contained'
        color='secondary'
        sx={{ mt: 3, mr: 2 }}
        onClick={() => setConfirming(true)}
      >
        {label}
      </Button>
      <CancelWorkFlowDialog
        worflowId={workflowCompletionId}
        open={confirming}
        setCloseDialog={setConfirming}
        onComplete={onWorkflowCancelled}
      />
    </>
  );
};
